<script>
  export let headlines;
  // export let pink = false;
  // export let white = false;
  export let large = false;

  $: headline = (() => {
    const headline = headlines.headline;
    if (!headline) return "";
    const type = headline.type.replace("heading", "");
    return `<h${type} class="text-6xl ${
      large ? "lg:text-8xl" : ""
    } font-extrabold">${headline.text.replace(/\n/g, "<br>")}</h${type}>`;
  })();
  $: subline = (() => {
    const headline = headlines.subline;
    if (!headline) return "";
    const type = headline.type.replace("heading", "");
    return `<h${type} class="text-xl ${
      large ? "lg:text-3xl" : ""
    } font-light"><span>${headline.text.replace(
      /\n/g,
      "<br>",
    )}</span></h${type}>`;
  })();
</script>

<div>
  {@html headline}
  {@html subline}
</div>
